import { useCustom, useCustomMutation } from '@refinedev/core';

export type TenantConfig = {
  id: string;
  companyId: string;
  authMethod: 'password' | 'sso_only';
};

export const useTenantConfig = (companyId: string) => {
  const { data, isLoading, isError, error, refetch } = useCustom<TenantConfig>({
    url: `admin/companies/${companyId}/config`,
    method: 'get',
    queryOptions: {
      enabled: !!companyId,
    },
  });

  return {
    config: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

type UpdateTenantConfigInput = {
  authMethod: 'password' | 'sso_only';
};

export const useUpdateTenantConfig = (companyId: string) => {
  const { mutateAsync, isLoading, error } = useCustomMutation<TenantConfig>();

  const updateConfig = async (input: UpdateTenantConfigInput) => {
    return mutateAsync({
      url: `admin/companies/${companyId}/config`,
      method: 'put',
      values: input,
    });
  };

  return {
    updateConfig,
    isLoading,
    error,
  };
};
